/* tslint:disable */
/* eslint-disable */
export enum WorkDebtorReminderFilterEnum {
  $1 = '1',
  $2 = '2',
  $3 = '3',
  Suspended = 'suspended'
}
